import React, { FC } from 'react'
import { WagmiConfig } from 'wagmi'
import { AppRoutes } from './routes/AppRoutes'
import { AuthProvider } from './context/AuthProvider'
import { wagmiClient } from './hooks/useWallet'
import 'antd/dist/reset.css'

// eslint-disable-next-line @typescript-eslint/no-var-requires,global-require
window.Buffer = window.Buffer || require('buffer').Buffer

const App: FC = () => {
  return (
    <AuthProvider>
      <WagmiConfig client={wagmiClient}>
        <AppRoutes />
      </WagmiConfig>
    </AuthProvider>
  )
}

export default App
